import { Component } from '@angular/core';
import { IcdCodeListComponent } from '../icd-code-list/icd-code-list';
import { IcdCodeType } from '../../../../core/api/mhsConfigurationApiClient';

@Component({
  selector: 'app-icd8-view',
  imports: [IcdCodeListComponent],
  templateUrl: './icd8-view.html',
  styleUrl: './icd8-view.scss',
})
export class Icd8ViewComponent {
  readonly codeType = IcdCodeType.Icd8;
}
